import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeDirectoryAPI } from "../../../Redux/Apis/employeeApi";
import Loader from "../../atoms/Loader/Loader";

const formatPhone = (countryCode, phoneNumber) => {
  const parts = [countryCode, phoneNumber].filter(
    (p) => p !== null && p !== undefined && String(p).trim() !== ""
  );
  return parts.length ? parts.join(" ") : "—";
};

const EmployeeDirectoryPage = () => {
  const dispatch = useDispatch();
  const { directoryUsers, directoryLoading } = useSelector((state) => state.employee);

  useEffect(() => {
    dispatch(getEmployeeDirectoryAPI());
  }, [dispatch]);

  return (
    <div>
      <div className="mb-4">
        <h1 className="page-title">Employee Directory</h1>
        <p className="page-subtitle">Name, email, and phone for colleagues.</p>
      </div>
      <div className="card-border card-body">
        {directoryLoading ? (
          <div className="w-full py-16 flex items-center justify-center">
            <Loader />
          </div>
        ) : (
          <table className="table-default w-full">
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              {directoryUsers.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center text-slate-500 py-8">
                    No directory entries found.
                  </td>
                </tr>
              ) : (
                directoryUsers.map((row) => (
                  <tr key={row.userId}>
                    <td>
                      <div className="w-20 h-20">
                        <img
                          className="rounded-full w-20 h-20 shadow-md"
                          src={row?.profileImage}
                          alt="profile"
                        />
                      </div>
                    </td>
                    <td>
                      {row.firstname} {row.lastname}
                    </td>
                    <td>{row.email ?? "—"}</td>
                    <td>{formatPhone(row.countryCode, row.phoneNumber)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default EmployeeDirectoryPage;
